import { assertEvent } from 'xstate5';

import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines if a provided ingredient is in stock.
 */
export const checkIfInStockIngredient: Guard = function (args): boolean {
  const { context, event } = args;

  assertEvent(event, [
    'customization.add-modification',
    'customization.dressing.increase-portions',
  ]);

  const { ingredientId } = event;
  const { allModificationsMap, modifications, modificationLimits } = context;

  // ─── Missing Data ────────────────────────────────────────────────────

  const hasMissingData = !modifications || !allModificationsMap || !modificationLimits;

  if (hasMissingData) {
    return false;
  }

  // ─────────────────────────────────────────────────────────────────────

  const modification = allModificationsMap.get(ingredientId);

  if (!modification) {
    return false;
  }

  return modification.outOfStock === false;
};
